import { Grid, TextField } from "@mui/material"
import { debounce } from "../../helpers/utils";

export const SearchRecords = ({ handlePagination, pagination }) => {

    const handleSearch = (val) => {
        let keywords = val.toLowerCase();
        handlePagination({
            ...pagination,
            keywords: keywords
        })
    }

    const processChange = debounce((e) => handleSearch(e));

    return (
        <Grid item xs={12} textAlign={"right"} pb={2} pt={1}>
            <TextField
                size="small"
                id="outlined-search"
                label="Search here..."
                type="search"
                onChange={(e) => processChange(e.target.value)}
            />
        </Grid>
    )
}